// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6YZcO","toggleWrap":"styles_toggleWrap__2sJGa","content":"styles_content__1pI3u","selectAreaCode":"styles_selectAreaCode___v6Z5"};